export const GET_RESE_LEAK_MONITORING_TABLE_DATA = {
    INIT: "GET_RESE_LEAK_MONITORING_TABLE_DATA_INIT",
    SUCCESS: "GET_RESE_LEAK_MONITORING_TABLE_DATA_SUCCESS",
    ERROR: "GET_RESE_LEAK_MONITORING_TABLE_DATA_ERROR",
};

export const GET_RESE_LEAK_MONITORING_MATERIAL_TYPE = {
    INIT: "GET_RESE_LEAK_MONITORING_MATERIAL_TYPE_INIT",
    SUCCESS: "GET_RESE_LEAK_MONITORING_MATERIAL_TYPE_SUCCESS",
    ERROR: "GET_RESE_LEAK_MONITORING_MATERIAL_TYPE_ERROR",
};

export const GET_RESE_LEAK_MONITORING_MATERIAL_DURATION = {
    INIT: "GET_RESE_LEAK_MONITORING_MATERIAL_DURATION_INIT",
    SUCCESS: "GET_RESE_LEAK_MONITORING_MATERIAL_DURATION_SUCCESS",
    ERROR: "GET_RESE_LEAK_MONITORING_MATERIAL_DURATION_ERROR",
};

export const POST_RESE_LEAK_MONITORING_INFORMATION = {
    INIT: "POST_RESE_LEAK_MONITORING_INFORMATION_INIT",
    SUCCESS: "POST_RESE_LEAK_MONITORING_INFORMATION_SUCCESS",
    ERROR: "POST_RESE_LEAK_MONITORING_INFORMATION_ERROR",
};

export const RESET_RESE_LEAK_MONITORING_SUBMIT_STATUS = "RESET_RESE_LEAK_MONITORING_SUBMIT_STATUS";
